const BRANDS_ROW1 = [
  { name: "ADN Kuruyemiş", img: "/images/ADN-KURUYEMIS-OSMANIYE-1-76031067.png" },
  { name: "Akdeniz Kebap", img: "/images/akdeniz-kebap-logo-c107eef4.png" },
  { name: "Akdeniz Reform", img: "/images/akdeniz-reform-insaat-logo-978daa49.png" },
  { name: "Altınordu Spor", img: "/images/altonordu-spor-logo-7a07bc4c.png" },
  { name: "Arifzade", img: "/images/ARIFZADE-CIGKOFTE-VE-MEZE-f2b06430.png" },
  { name: "CarnevalKids", img: "/images/carnavalkids-logo-5c8bb033.png" },
  { name: "Cızzgara", img: "/images/CIZZGARA-LOGO-3fbd4bd6.png" },
  { name: "Corner Cafe", img: "/images/CORNER-LOUNGUE-CAFE-LOGO-9d1a1328.png" },
  { name: "Emsav Emniyet", img: "/images/emsav-emniyet-logo-86de7dac.png" },
  { name: "Emsav", img: "/images/emsav-logo-1-84e012ea.png" },
  { name: "Ergün Oto", img: "/images/ERGUN-OTO-LOGO-d4f1f619.png" },
  { name: "Essel Kağıt", img: "/images/essel-kagit-logo-scaled-e6a4cfdb.png" },
  { name: "Baylaz Group", img: "/images/referans/BAYLAZ%20GROUP.jpg" },
  { name: "Karaca Home", img: "/images/referans/Karaca-Home-New-2022-Logo-Vector.svg-.png" },
  { name: "Sevgi Hastahanesi", img: "/images/referans/SEVG%C4%B0%20HASTAHANES%C4%B0.png" },
];

const BRANDS_ROW2 = [
  { name: "Hadise", img: "/images/hadise-logo-63b8eba3.png" },
  { name: "Kemal Pastanesi", img: "/images/kemal-pastanesi-efe479ea.png" },
  { name: "Kepirler Künefe", img: "/images/kepirler-kunefe-logo-857d44ad.png" },
  { name: "Lavas Center", img: "/images/lavas-canter-logo-cd9ca80b.png" },
  { name: "MG Dino Döner", img: "/images/mg-dino-doner-logo-c62baec7.png" },
  { name: "Bakraç Cafe", img: "/images/osmaniye-bakrach-cafe-logo-63209019.png" },
  { name: "Büyük Otel", img: "/images/osmaniye-buyuk-oteli-logo-2-61883df7.png" },
  { name: "Osmaniyespor", img: "/images/osmaniye-spor-logo-d60e0788.png" },
  { name: "OSB", img: "/images/osmaniye-osb-logo-44adce8b.webp" },
  { name: "Uçrak", img: "/images/UGRAK-LOGO-0d96e870.png" },
  { name: "Yöresel Reyon", img: "/images/yoresel-reyon-gurme-logo-f1bdeac7.png" },
  { name: "Arifzade Çiğköfte ve Meze", img: "/images/referans/AR%C4%B0FZADE%20%C3%87%C4%B0%C4%9EK%C3%96FTE%20VE%20MEZE.png" },
  { name: "Mono Çelik Kapı", img: "/images/referans/mono%20%C3%A7elik%20kap%C4%B1.jpg" },
  { name: "Öncü", img: "/images/referans/%C3%B6nc%C3%BC%20png.png" },
  { name: "ADN Kuruyemiş", img: "/images/ADN-KURUYEMIS-OSMANIYE-1-76031067.png" },
];

interface BrandItem { name: string; img: string; }

const BrandCard = ({ brand }: { brand: BrandItem }) => (
  <div className="flex items-center justify-center px-10 py-6 bg-white/5 border border-white/8 hover:border-[#E6A800]/50 hover:bg-white/10 tr cursor-default group shrink-0 mx-2 w-[230px] h-[110px]">
    <img
      src={brand.img}
      alt={brand.name}
      className="max-h-[72px] max-w-[180px] object-contain filter brightness-75 group-hover:brightness-100 tr"
    />
  </div>
);

const BrandsMarquee = () => {
  const row1 = [...BRANDS_ROW1, ...BRANDS_ROW1];
  const row2 = [...BRANDS_ROW2, ...BRANDS_ROW2];

  return (
    <section className="bg-[#1A1A1A] pt-24 pb-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-16">
        <div className="anim-left">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
              Güven &amp; Başarı
            </span>
          </div>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <h2 className="font-head font-black uppercase text-white text-5xl md:text-6xl leading-[0.9]">
              Önde Gelen Markaların
              <br />
              <span className="text-[#E6A800]">Başarısını Destekliyoruz</span>
            </h2>
            <p className="text-white/50 text-base max-w-sm leading-relaxed">
              Osmaniye ve çevresinden 300'den fazla marka &amp; işletmeyle
              ortak başarı hikayeleri yazdık.
            </p>
          </div>
        </div>
      </div>

      {/* Row 1 - left */}
      <div className="marquee-track mb-3 relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none bg-gradient-to-r from-[#1A1A1A] to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none bg-gradient-to-l from-[#1A1A1A] to-transparent" />
        <div className="flex marquee-left">
          {row1.map((b, i) => (
            <BrandCard key={`r1-${i}`} brand={b} />
          ))}
        </div>
      </div>

      {/* Row 2 - right */}
      <div className="marquee-track relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none bg-gradient-to-r from-[#1A1A1A] to-transparent" />
        <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none bg-gradient-to-l from-[#1A1A1A] to-transparent" />
        <div className="flex marquee-right">
          {row2.map((b, i) => (
            <BrandCard key={`r2-${i}`} brand={b} />
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-10">
        <div className="flex items-center justify-between">
          <p className="text-white/25 text-xs font-head uppercase tracking-widest">
            300+ Marka &amp; İşletme · 18 Şehir · 20 Yıl Tecrübe
          </p>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E6A800] animate-pulse" />
            <span className="text-white/25 text-xs font-head uppercase tracking-widest">
              Aktif Referanslar
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsMarquee;